// extracted by mini-css-extract-plugin
export default {"wrapper":"MR-z","availablePromoMessagesLabel":"NR-z","promoMessageList":"OR-z","promoMessage":"PR-z","appliedPromoMessage":"QR-z","promoMessageAmount":"RR-z"};